var dp = "./data/";
export var companyTypeOptions = require(dp + "companyTypeOptions.json");

export var originOptions = require(dp + "productOriginOptions.json");

/**
 * all the products and grades
 */
export var productTypeOptions = require(dp + "productTypeOptions.json");

export var favoriteProductOptions = require(dp + "favoriteProductOptions.json");

export var productGradeOptions = require(dp + "productGradeOptions.json");

export var qualityStandardOptions = require(dp + "qualityStandardOptions.json");

export var productQualityParameters = require(dp +
  "productQualityParameters.json");

export var bidExpiryOptions = require(dp + "bidExpiryOptions.json");

export var qtyToleranceOptions = require(dp + "qtyToleranceOptions.json");

export var locationModeOptions = require(dp + "locationModeOptions.json");

export var paymentTermsOptions = require(dp + "paymentTermsOptions.json");

export var paymentModeOptions = require(dp + "paymentModeOptions.json");

export var threadStatusOptions = require(dp + "threadStatusOptions.json");

export var contractOptions = require(dp + "contractOptions.json");

export var specialVehicleOptions = require(dp + "specialVehicleOptions.json");

export var deFarmerVatStatusOptions = require(dp +
  "deFarmerVatStatusOptions.json");

export var languageOptions = require(dp + "languageOptions.json");

export var userStatusOptions = require(dp + "userStatusOptions.json");

export var userRoleOptions = require(dp + "userRoleOptions.json");

export var priceIndicationStatusOptions = require(dp +
  "priceIndicationStatusOptions.json");

export var dashboardArticleColoring = require(dp +
  "dashboardArticleColoring.json");

export var salutationOptions = require(dp + "salutationOptions.json");

export var monthLabels = [
  "Jan",
  "Feb",
  "Mär",
  "Apr",
  "Mai",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Okt",
  "Nov",
  "Dez",
];

export var monthLabelsEn = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export var monthLongLabels = [
  "Januar",
  "Februar",
  "März",
  "April",
  "Mai",
  "Juni",
  "Juli",
  "August",
  "September",
  "Oktober",
  "November",
  "Dezember",
];

export var monthLongLabelsEn = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "Oktober",
  "November",
  "December",
];

export var standardHubs = require(dp + "standardHubs.json");

export var dateModeOptions = require(dp + "dateModeOptions.json");

export var countryOptions = require(dp + "countryOptions.json");

export var articleCustomSortOrder = require(dp + "articleCustomSortOrder.json");

export function getLabel(key, optionsList) {
  let iter =
    typeof optionsList == "object"
      ? Object.values(optionsList).flat()
      : optionsList;

  for (var option of iter) {
    if (option.id == key) {
      return option.name ?? option.label;
    }
  }
  return null;
}

export function getLocalizedLabel(key, optionsList) {
  return __(this.getLabel(key, optionsList));
}

export function getShortLabel(key, optionsList) {
  let iter =
    typeof optionsList == "object"
      ? Object.values(optionsList).flat()
      : optionsList;

  for (var option of iter) {
    if (option.id == key) {
      return option.name_short ?? option.label;
    }
  }
  return null;
}

export function getLocalizedWheatOtherLabel(protein_min) {
  return __("B-Wheat") + " (" + __("Oth.") + " " + protein_min + "% Prot.)";
}

export function getProductQualityParameters(productType, productGrade) {
  let productOptions = this.productQualityParameters[productType] || [],
    gradeOptions = this.productQualityParameters[productGrade] || [];

  let productQualityParameters = productOptions.concat(gradeOptions);

  if (productGrade == "WHEAT_F") {
    // exceptionally, F-Wheat does not have some attributes that other product WHEAT have (like protein)
    // => remove those product quality parameters that are not included in the F-WHEAT quality standard
    let qualityStandardOptions = this.qualityStandardOptions[productGrade][0];
    productQualityParameters = productQualityParameters.filter((t) => {
      return qualityStandardOptions[t.id] != null;
    });
  }
  return productQualityParameters;
}

export function locationToString(tradable) {
  if (!tradable) {
    return "";
  }

  let loc = tradable.location || tradable,
    locModeString = window.__(getLabel(loc.mode, locationModeOptions)),
    res = locModeString + " ";

  if (loc.hub != null) {
    let hubName = getLabel(loc.hub, standardHubs);
    res = window.__(hubName);
  } else if (loc.address.zip == null) {
    // no address provided - just the location mode string
  } else {
    if (loc.distance_max != null) {
      res =
        res +
        " " +
        window.__("in a radius of") +
        " " +
        loc.distance_max +
        " km um";
    }
    res = res + " " + loc.address.zip + " " + loc.address.city;

    if (loc.address.country != null && loc.address.country != "DE") {
      res = res + " (" + loc.address.country + ")";
    }

    if (loc.optional_transport) {
      if (loc.mode == "FCA" || loc.mode == "DAP") {
        let label = loc.mode == "FCA" ? "Delivery" : "Pick-up";
        res = res + " " + window.__("(" + label + " possible)");
      }
    }
  }

  return res;
}

export function dateToString(tradable, locale = "de", short = false) {
  if (!tradable) {
    return "";
  }

  let d = tradable.date,
    res = "";

  if (locale == "de") {
    switch (d.type) {
      case "AT_HARVEST":
        res = "Ex Ernte";
        break;
      case "MONTH":
        res = "Im Monat " + dateToMonthLocalizedString(d.month_to);
        break;
      case "MULTIPLE":
        res =
          "Verbandlich von " +
          dateToMonthLocalizedString(d.month_from) +
          " bis " +
          dateToMonthLocalizedString(d.month_to);
        if (!short) {
          res +=
            " (" +
            (d.multiple_mode == "CONSECUTIVE"
              ? "Sukzessive"
              : "Nach Absprache") +
            ")";
        }
        break;
      case "BASIS":
        res =
          "Basis " +
          dateToMonthLocalizedString(d.month_from) +
          "; Erfüllung bis " +
          dateToMonthLocalizedString(d.month_to);
        if (d.storage_fee != null && !short) {
          res =
            res +
            " (Lagergeld: " +
            formatLocalizedNumber(d.storage_fee) +
            " €/t)";
        }
        break;
      case "STAGGERED":
        res =
          "Staffelvermarktung von " +
          dateToMonthLocalizedString(d.month_from) +
          " bis " +
          dateToMonthLocalizedString(d.month_to);

        break;

      default:
        res =
          d.type +
          " " +
          dateToMonthLocalizedString(d.month_from) +
          " " +
          dateToMonthLocalizedString(d.month_to);
    }
  } else {
    switch (d.type) {
      case "AT_HARVEST":
        res = "At Harvest";
        break;
      case "MONTH":
        res = "Month " + dateToMonthLocalizedStringEn(d.month_to);
        break;
      case "MULTIPLE":
        res =
          "Months from " +
          dateToMonthLocalizedStringEn(d.month_from) +
          " to " +
          dateToMonthLocalizedStringEn(d.month_to);
        if (!short) {
          res +=
            " (" +
            (d.multiple_mode == "CONSECUTIVE" ? "Successive" : "By agreement") +
            ")";
        }
        break;
      case "BASIS":
        res =
          "Months from " +
          dateToMonthLocalizedStringEn(d.month_from) +
          " until " +
          dateToMonthLocalizedStringEn(d.month_to);
        if (!short && d.storage_fee != null) {
          res = res + " (Storage fee: " + d.storage_fee + " €/t)";
        }
        break;
      case "STAGGERED":
        res =
          "Staggered sales from " +
          dateToMonthLocalizedStringEn(d.month_from) +
          " until " +
          dateToMonthLocalizedStringEn(d.month_to);

        break;
      default:
        res =
          d.type +
          " " +
          dateToMonthLocalizedStringEn(d.month_from) +
          " " +
          dateToMonthLocalizedStringEn(d.month_to);
    }
  }

  return res;
}

export function dateToMonthLocalizedString(d, locale = "de") {
  if (locale == "en") {
    return dateToMonthLocalizedStringEn(d);
  }
  if (typeof d == "string") {
    d = new Date(d);
  }
  return monthLabels[d.getMonth()] + " " + d.getFullYear();
}

export function dateToMonthLocalizedStringEn(d) {
  if (typeof d == "string") {
    d = new Date(d);
  }
  return monthLabelsEn[d.getMonth()] + " " + d.getFullYear();
}

export function formatIsoStamp(ts) {
  return ts == null ? null : `${ts.substr(0, 10)} ${ts.substr(11, 5)}`;
}

export var harvestYearOptions = ["2024", "2025", "2026"];

export function getPaperHubs() {
  return standardHubs.filter((h) => h.paper_enabled == true);
}

export function formatLocalizedNumber(val, dp = 2) {
  if (val === null) {
    return "";
  }
  let num = typeof val == "string" ? val * 1 : val,
    f = num.toFixed(dp);
  if (window.locale == "de") {
    f = f.replace(".", ",");
  }
  return f;
}
